import React from "react";
import { List, Card, Button, Avatar, Icon, Rate, Popconfirm, Tag } from "antd";
import CodingIcon from '../../../overview/assets/codingIcon.png'
const { Meta } = Card;
export function InternshipsList({
  technicalSkills
}) {
  return (
    <List
    pagination={{pageSize:2}}
    grid={{
      gutter: 8,
      xs: 1,
    sm: 1,
    md: 1,
    lg: 3,
    xl: 3,
    xxl: 3,
    }}
      dataSource={technicalSkills&&technicalSkills &&  [
        ...Object.keys(technicalSkills).map((el, index) => {
          return {
            ...technicalSkills[el],
            index
          };
        })
      ]}
      renderItem={item => {
        if (item && item.internshipTitle) {
          return (
            <List.Item key={item.internshipTitle}>
              <Card>
                <Meta
                 
                  title={item.internshipTitle}
                />
                <div
                  style={{
                    marginTop: 13
                  }}
                >
                  Internship Rating :{" "}
                  <Rate
                    allowHalf
                    style={{
                      fontSize: 17
                    }}
                    value={item.internshipRate}
                    disabled
                  />
                </div>
                <div
                  style={{
                    marginTop: 2
                  }}
                >
                  <Icon type="book" />
                  Company : {item.internshipAuthority}{" "}
                </div>
                <div
                  style={{
                    marginTop: 2
                  }}
                >
                  <Icon type="clock-circle" /> {item.internshipDate}
                </div>
                <div
                  style={{
                    marginTop: 10
                  }}
                >
                  {item.skillLearntAtInternship.map(i => (
                    <Tag style={{ marginBottom: 5 }} key={i}>
                      {i.toUpperCase()}
                    </Tag>
                  ))}{" "}
                </div>
              </Card>
            </List.Item>
          );
        }
    }}
      
    />
  );
}
